export enum AuditChannel {
  CREATE = 'audit::create',
  EDIT = 'audit::patch',
  DELETE = 'audit::delete',
}
